// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"18f7d72f","703":"e194b5e6","787":"58912f3a"}[chunkId] + ".chunk.js";
};